import { ptTime } from "@/lib/api";

const cents = (x) => (x == null ? "—" : `${x}¢`);

export default function NearMisses({ rows }) {
  return (
    <div data-testid="near-misses" className="space-y-1">
      <div className="text-[10px] uppercase tracking-widest text-[var(--text-mute)]">
        Near-misses today · moves at 80–99% of the trigger <span data-testid="near-miss-count" className="text-[var(--text-dim)]">({rows.length})</span>
      </div>
      <div className="overflow-auto max-h-64 rounded-lg border border-[var(--border-subtle)]">
        <table className="w-full text-xs font-mono-num whitespace-nowrap">
          <thead className="text-[10px] uppercase tracking-widest text-[var(--text-mute)] text-left">
            <tr>{["Time (PT)", "Asset", "Move", "Need", "Reached", "Lookback", "Side", "Side ask", "Contracts"].map((h) => <th key={h} className="px-2 py-2">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={9} className="px-2 py-3 text-[var(--text-mute)]">No near-misses yet today</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`near-miss-row-${r.id}`} className="border-t border-[var(--border-subtle)]">
                <td className="px-2 py-1.5">{ptTime(r.ts)}</td><td className="px-2">{r.asset}</td>
                <td className="px-2">{r.delta > 0 ? "+" : "-"}${Math.abs(r.delta)}</td><td className="px-2">±${r.threshold}</td>
                <td className="px-2 text-amber-300">{r.pct_of_threshold}%</td><td className="px-2">{r.window}s</td>
                <td className="px-2">{(r.side || r.direction || "—").toUpperCase()}</td><td className="px-2">{cents(r.ask_cents)}</td><td className="px-2">{r.depth ?? "—"}</td>
              </tr>))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
